import env from "react-dotenv";
import { parseJSON } from "../../helpers/json";
import { API_ENDPOINT } from '../../constants';

export default {
    'api1': {
        onLoad: true,
        action: (lang, match, query) => {
            return fetch(API_ENDPOINT + '/data/stock-clients', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },

                body: JSON.stringify({
                    page: query.page,
                    entries: query.entries,
                    filter: query.filter,
                    sortType: query.sortType,
                    sortField: query.sortField,

                })
            }).then(parseJSON).then(({ result, status }) => {
                if (status >= 200 && status < 300)
                    return {
                        items: result.items,
                        total: result.total,
                    }
            })
        }
    },
    'api2': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/stock-clients/new', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data.data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    'api3': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/stock-clients/' + data.data, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                //body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    'api4': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/stock-clients/' + data.data._id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data.data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },
    'api5': {
        onLoad: true,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/user-levels', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify({
                    page: null,
                    entries: null,
                    filter: null,
                    sortType: null,
                    sortField: null,
                })
            }).then(parseJSON).then(({ result, status }) => {
                console.log(result)
                if (status >= 200 && status < 300)
                    return {
                        userLevels: result,
                    }
            })
        }
    },



    'validate': {
        onLoad: false,
        action: (data) => {
            console.log("VALIDATION")
            return fetch(API_ENDPOINT + '/data/stock-clients/validate/' + data.value + '/' + data.id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    }

}